import React from 'react';
import { Flower2, Sun, Leaf, Snowflake } from 'lucide-react';
import { seasonalData } from '../data/mock';

const iconMap = {
  Flower2, Sun, Leaf, Snowflake
};

const SeasonalSection = () => {
  return (
    <section id="seasons" className="section-spacing" style={{ background: 'var(--color-coastal-fog)' }}>
      <div className="container-coastal">
        <div className="text-center mb-xl">
          <h2 className="section-title">{seasonalData.title}</h2>
          <p className="section-subtitle" style={{ maxWidth: '700px', margin: '0 auto' }}>
            From spring blooms to winter wonderland, Schoodic Peninsula offers unforgettable 
            experiences in every season
          </p>
        </div>

        <div className="grid-2">
          {seasonalData.seasons.map((season, index) => {
            const IconComponent = iconMap[season.icon];
            
            return (
              <div 
                key={index} 
                className="card-coastal"
                style={{
                  background: 'white',
                  position: 'relative',
                  overflow: 'hidden'
                }}
              >
                <div 
                  style={{
                    position: 'absolute',
                    top: '-50px',
                    right: '-50px',
                    width: '200px',
                    height: '200px',
                    background: 'var(--color-coastal-fog)',
                    borderRadius: '50%',
                    opacity: 0.5
                  }}
                />
                
                <div style={{ position: 'relative', zIndex: 2 }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 'var(--spacing-md)',
                    marginBottom: 'var(--spacing-md)'
                  }}>
                    <div style={{
                      width: '60px',
                      height: '60px',
                      borderRadius: '50%',
                      background: 'var(--color-ocean-deep)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <IconComponent size={32} color="white" />
                    </div>
                    <div>
                      <h3 className="card-title" style={{ marginBottom: '0.25rem' }}>
                        {season.name}
                      </h3>
                      <p className="small-text" style={{ fontWeight: '600', color: 'var(--color-ocean-deep)' }}>
                        {season.months}
                      </p>
                    </div>
                  </div>

                  <p className="body-text mb-md">{season.description}</p>

                  <div 
                    className="image-overlay-container"
                    style={{
                      height: '200px',
                      marginBottom: 'var(--spacing-md)'
                    }}
                  >
                    <img 
                      src={season.image} 
                      alt={`${season.name} in Maine`}
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  </div>

                  <div>
                    <h4 style={{ 
                      fontSize: '1rem',
                      fontWeight: '600',
                      marginBottom: 'var(--spacing-sm)',
                      color: 'var(--color-dark-slate)'
                    }}>
                      Seasonal Highlights:
                    </h4>
                    <ul style={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      gap: '0.5rem',
                      listStyle: 'none',
                      padding: 0
                    }}>
                      {season.highlights.map((highlight, idx) => (
                        <li 
                          key={idx}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            fontSize: '0.9375rem',
                            color: 'var(--color-granite-gray)'
                          }}
                        >
                          <div style={{
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: 'var(--color-ocean-deep)',
                            flexShrink: 0
                          }} />
                          {highlight}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SeasonalSection;
